import AnexoSolicitacaoService from "../../services/resource/anexoSolicitacaoService";

const service = new AnexoSolicitacaoService();

// Cache em memória (por aba) dos arquivos de anexo já baixados, para abrir de novo sem baixar outra
// vez. A chave inclui tamanho e descrição porque a assinatura de PDF substitui o arquivo mantendo o
// mesmo id (ver AnexoService.substituirArquivo) — assim a versão assinada nunca cai no cache antigo.
const LIMITE_BYTES = 150 * 1024 * 1024;
// Pré-carregamento só de arquivos menores, para não gastar banda com anexos grandes que talvez nem sejam abertos.
const LIMITE_PRE_CARREGAMENTO_BYTES = 8 * 1024 * 1024;

const cache = new Map();
let totalBytes = 0;
let filaPreCarregamento = Promise.resolve();

function chave(anexo) {
    return `${anexo.id}:${anexo.tamanho}:${anexo.descricao ?? ""}`;
}

function liberarEspaco() {
    for (const [k, entrada] of cache) {
        if (totalBytes <= LIMITE_BYTES) break;
        if (!entrada.blob) continue;
        URL.revokeObjectURL(entrada.url);
        totalBytes -= entrada.blob.size;
        cache.delete(k);
    }
}

/** Retorna { blob, url } do anexo — baixa só na primeira vez; chamadas simultâneas compartilham o mesmo download. */
export function obterArquivoAnexo(anexo) {
    const k = chave(anexo);
    const existente = cache.get(k);
    if (existente) {
        // Reinsere no fim do Map para funcionar como LRU (os mais antigos são descartados primeiro).
        cache.delete(k);
        cache.set(k, existente);
        return existente.promessa;
    }

    const entrada = { blob: null, url: null, promessa: null };
    entrada.promessa = service.baixarAnexo(anexo.id)
        .then(res => {
            entrada.blob = res.data;
            entrada.url = URL.createObjectURL(res.data);
            totalBytes += res.data.size;
            liberarEspaco();
            return { blob: entrada.blob, url: entrada.url };
        })
        .catch(erro => {
            cache.delete(k);
            throw erro;
        });
    cache.set(k, entrada);
    return entrada.promessa;
}

/** Baixa em segundo plano, um de cada vez (o proxy limita conexões simultâneas na rota de anexos). */
export function preCarregarAnexos(anexos, filtro) {
    anexos
        .filter(anexo => filtro(anexo) && anexo.tamanho <= LIMITE_PRE_CARREGAMENTO_BYTES && !cache.has(chave(anexo)))
        .forEach(anexo => {
            filaPreCarregamento = filaPreCarregamento
                .then(() => obterArquivoAnexo(anexo))
                .catch(() => {});
        });
}
